import React from "react";
import classNames from "classnames";
import { SelectList } from "@common/selectList";
import { Props } from "./types";
import { ArrowIcon } from "./arrowIcon";
import { FrenchIcon } from "./frenchIcon";
import { EnglishIcon } from "./englishIcon";
import styles from "./styles.scss";

function LanguageSelection(props: Props) {
  return props.isDisabled ? (
    <div className={classNames(styles.languageSelection, styles.disabled)}>
      {props.selectedLanguage ? (
        <div className={styles.input}>
          {props.selectedLanguage === "fr" ? (
            <FrenchIcon className={styles.langIcon} />
          ) : (
            <EnglishIcon className={styles.langIcon} />
          )}
          <p className={styles.selection}>
            {props.selectedLanguage.toUpperCase()}
          </p>
          <div className={styles.iconBox}>
            <ArrowIcon className={styles.icon} />
          </div>
        </div>
      ) : (
        <div className={styles.input}>
          <p className={classNames(styles.selection, styles.placeholder)}>
            {props.placeholder}
          </p>
          <div className={styles.iconBox}>
            <ArrowIcon className={styles.icon} />
          </div>
        </div>
      )}
    </div>
  ) : (
    <SelectList
      listClassName={styles.list}
      rootClassName={props.isInvalid ? styles.invalid : undefined}
    >
      {({ isOpen, select }) => ({
        input: (
          <div
            className={classNames(styles.languageSelection, {
              [styles.opened]: isOpen,
            })}
          >
            {props.selectedLanguage ? (
              <div className={styles.input}>
                {props.selectedLanguage === "fr" ? (
                  <FrenchIcon className={styles.langIcon} />
                ) : (
                  <EnglishIcon className={styles.langIcon} />
                )}
                <p className={styles.selection}>
                  {props.selectedLanguage.toUpperCase()}
                </p>
                <div className={styles.iconBox}>
                  <ArrowIcon className={styles.icon} />
                </div>
              </div>
            ) : (
              <div className={styles.input}>
                <p className={classNames(styles.selection, styles.placeholder)}>
                  {props.placeholder}
                </p>
                <div className={styles.iconBox}>
                  <ArrowIcon className={styles.icon} />
                </div>
              </div>
            )}
          </div>
        ),
        list: (
          <ul>
            <li
              className={classNames(styles.language, {
                [styles.selectedLanguage]: props.selectedLanguage === "fr",
              })}
              onClick={() => select(props.select("fr"))}
            >
              <FrenchIcon className={styles.langIcon} />
              <p className={styles.name}>FR</p>
            </li>
            <li
              className={classNames(styles.language, {
                [styles.selectedLanguage]: props.selectedLanguage === "en",
              })}
              onClick={() => select(props.select("en"))}
            >
              <EnglishIcon className={styles.langIcon} />
              <p className={styles.name}>EN</p>
            </li>
          </ul>
        ),
      })}
    </SelectList>
  );
}

export { LanguageSelection };
